
import React, { useLayoutEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function PrivacyPage() {
  const navigate = useNavigate();
  const pageTopRef = useRef(null);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
    }
  }, []);

  const handleBack = () => {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }

    navigate(-1);
  };

  return (
    <div ref={pageTopRef} className="privacy-page">
      <style>{`
        .privacy-page {
          min-height: 100vh;
          background: #f7faf8;
          color: #111827;
          font-family: Inter, "Avenir Next", Arial, sans-serif;
          line-height: 1.65;
        }

        .privacy-shell {
          max-width: 960px;
          margin: 0 auto;
          padding: 34px 24px 72px;
        }

        .privacy-back {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 26px;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .privacy-back:hover {
          text-decoration: underline;
        }

        .privacy-back-button {
          border: none;
          background: transparent;
          padding: 0;
          cursor: pointer;
          font-family: inherit;
        }

        .privacy-hero {
          padding: 46px 44px;
          margin-bottom: 26px;
          border-radius: 28px;
          color: #ffffff;
          background: linear-gradient(135deg, #0c6943 0%, #148a58 100%);
          box-shadow: 0 18px 48px rgba(20, 138, 88, 0.16);
        }

        .privacy-hero-label {
          display: inline-flex;
          padding: 6px 13px;
          margin-bottom: 18px;
          border: 1px solid rgba(255, 255, 255, 0.25);
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.13);
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        .privacy-hero h1 {
          margin: 0 0 13px;
          font-size: clamp(34px, 5vw, 47px);
          font-weight: 760;
          line-height: 1.1;
          letter-spacing: -0.045em;
        }

        .privacy-hero-description {
          max-width: 720px;
          margin: 0;
          color: rgba(255, 255, 255, 0.9);
          font-size: 16px;
        }

        .privacy-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 11px;
          margin-top: 30px;
        }

        .privacy-meta-item {
          padding: 9px 13px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.11);
          color: rgba(255, 255, 255, 0.94);
          font-size: 13px;
        }

        .privacy-card {
          padding: 30px 32px;
          margin-bottom: 17px;
          border: 1px solid #e3ebe6;
          border-radius: 22px;
          background: #ffffff;
          box-shadow: 0 5px 22px rgba(17, 24, 39, 0.035);
        }

        .privacy-card h2 {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 0 0 16px;
          color: #111827;
          font-size: 21px;
          font-weight: 720;
          letter-spacing: -0.02em;
        }

        .privacy-number {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 11px;
          background: #e9f6ef;
          color: #148a58;
          font-size: 14px;
          font-weight: 750;
        }

        .privacy-card p {
          margin: 0 0 13px;
          color: #374151;
          font-size: 15px;
        }

        .privacy-card p:last-child {
          margin-bottom: 0;
        }

        .privacy-list {
          margin: 8px 0 0;
          padding-left: 21px;
          color: #374151;
          font-size: 15px;
        }

        .privacy-list li {
          margin-bottom: 9px;
          padding-left: 3px;
        }

        .privacy-list li:last-child {
          margin-bottom: 0;
        }

        .privacy-highlight {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #148a58;
          border-radius: 13px;
          background: #f1faf5;
          color: #244536;
          font-size: 14px;
        }

        .privacy-warning {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #d59b25;
          border-radius: 13px;
          background: #fffaf0;
          color: #594019;
          font-size: 14px;
        }

        .privacy-link {
          color: #148a58;
          font-weight: 600;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        .privacy-details {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
          margin-top: 18px;
        }

        .privacy-detail-box {
          padding: 15px 16px;
          border: 1px solid #e3ebe6;
          border-radius: 14px;
          background: #f8fbf9;
        }

        .privacy-detail-label {
          display: block;
          margin-bottom: 4px;
          color: #64748b;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }

        .privacy-detail-value {
          color: #24372d;
          font-size: 14px;
          font-weight: 550;
        }

        .privacy-table-wrapper {
          width: 100%;
          margin-top: 20px;
          overflow-x: auto;
          border: 1px solid #e3ebe6;
          border-radius: 16px;
        }

        .privacy-table {
          width: 100%;
          min-width: 780px;
          border-collapse: collapse;
          background: #ffffff;
          font-size: 14px;
        }

        .privacy-table th {
          padding: 14px 15px;
          border-bottom: 1px solid #e3ebe6;
          background: #f1f7f3;
          color: #24372d;
          font-size: 13px;
          font-weight: 720;
          text-align: left;
        }

        .privacy-table td {
          padding: 15px;
          border-bottom: 1px solid #edf2ee;
          color: #374151;
          vertical-align: top;
        }

        .privacy-table tr:last-child td {
          border-bottom: none;
        }

        .privacy-tag {
          display: inline-flex;
          padding: 4px 9px;
          border-radius: 999px;
          background: #e9f6ef;
          color: #0f6c45;
          font-size: 12px;
          font-weight: 720;
          white-space: nowrap;
        }

        .privacy-tag-third-party {
          display: inline-flex;
          padding: 4px 9px;
          border-radius: 999px;
          background: #edf3ff;
          color: #264f98;
          font-size: 12px;
          font-weight: 720;
          white-space: nowrap;
        }

        .privacy-documents {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
          margin-top: 18px;
        }

        .privacy-document-link {
          display: block;
          padding: 14px 15px;
          border: 1px solid #e3ebe6;
          border-radius: 13px;
          background: #f8fbf9;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .privacy-document-link:hover {
          border-color: #b8dcc8;
          background: #f1faf5;
        }

        .privacy-contact {
          padding: 30px 32px;
          margin-top: 20px;
          border-radius: 22px;
          background: #10271e;
          color: #ffffff;
        }

        .privacy-contact h2 {
          margin: 0 0 10px;
          font-size: 21px;
          letter-spacing: -0.02em;
        }

        .privacy-contact p {
          margin: 0 0 14px;
          color: rgba(255, 255, 255, 0.82);
          font-size: 15px;
        }

        .privacy-contact a {
          color: #ffffff;
          font-weight: 650;
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        .privacy-footer {
          padding-top: 30px;
          color: #64748b;
          font-size: 13px;
          text-align: center;
        }

        @media (max-width: 640px) {
          .privacy-shell {
            padding: 20px 15px 48px;
          }

          .privacy-hero {
            padding: 32px 23px;
            border-radius: 21px;
          }

          .privacy-card,
          .privacy-contact {
            padding: 23px 20px;
            border-radius: 18px;
          }

          .privacy-card h2 {
            align-items: flex-start;
            font-size: 19px;
          }

          .privacy-details,
          .privacy-documents {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <main className="privacy-shell">
        <button
          type="button"
          className="privacy-back privacy-back-button"
          onClick={handleBack}
        >
          ← Back to EcoTrack
        </button>

        <header className="privacy-hero">
          <div className="privacy-hero-label">Legal Information</div>

          <h1>Privacy Policy</h1>

          <p className="privacy-hero-description">
            This Privacy Policy explains how personal data are processed in
            connection with EcoTrack, a digital ESG self-assessment and support
            service provided for business and professional users.
          </p>

          <div className="privacy-meta">
            <div className="privacy-meta-item">Last updated: 31 May 2026</div>
            <div className="privacy-meta-item">Viridis by Serap Cevirgen</div>
            <div className="privacy-meta-item">VAT No. 04191120130</div>
          </div>
        </header>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">1</span>
            Data controller
          </h2>

          <p>
            The controller of personal data processed in connection with
            EcoTrack is:
          </p>

          <div className="privacy-details">
            <div className="privacy-detail-box">
              <span className="privacy-detail-label">Controller</span>
              <span className="privacy-detail-value">
                Viridis by Serap Cevirgen
              </span>
            </div>

            <div className="privacy-detail-box">
              <span className="privacy-detail-label">VAT number</span>
              <span className="privacy-detail-value">04191120130</span>
            </div>

            <div className="privacy-detail-box">
              <span className="privacy-detail-label">Business address</span>
              <span className="privacy-detail-value">
                Via Luigi Dottesio n. 24, 22100 Como (CO), Italy
              </span>
            </div>

            <div className="privacy-detail-box">
              <span className="privacy-detail-label">Privacy contact</span>
              <span className="privacy-detail-value">
                serap.cevirgen@viridisconsultancy.com
              </span>
            </div>
          </div>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">2</span>
            Scope and nature of EcoTrack
          </h2>

          <p>
            <strong>2.1</strong> EcoTrack is a digital ESG self-assessment and
            support tool intended exclusively for business and professional
            users acting in connection with a trade, business or professional
            activity.
          </p>

          <p>
            <strong>2.2</strong> EcoTrack may allow authorised users to create
            an account, provide organisation profile information, complete ESG
            questionnaires, view calculated scores and summaries, receive
            suggestions and download related outputs.
          </p>

          <p>
            <strong>2.3</strong> This Policy concerns personal data relating
            to identifiable natural persons, including account users, business
            contacts, sole professionals and persons communicating with the
            Controller. Information relating only to a company may not be
            personal data unless it identifies or relates to a natural person.
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">3</span>
            Personal data we process
          </h2>

          <p>
            Depending on how EcoTrack is used, the following categories of
            personal data may be processed:
          </p>

          <div className="privacy-table-wrapper">
            <table className="privacy-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Examples</th>
                  <th>Source</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <strong>Account and authentication data</strong>
                  </td>
                  <td>
                    Email address, user identifier, login and authentication
                    information.
                  </td>
                  <td>Provided by the user or generated through login.</td>
                </tr>

                <tr>
                  <td>
                    <strong>Organisation profile and onboarding data</strong>
                  </td>
                  <td>
                    Organisation information, sector, size, operating region,
                    ESG objective or other profile selections provided in the
                    onboarding process.
                  </td>
                  <td>Provided by the user.</td>
                </tr>

                <tr>
                  <td>
                    <strong>Assessment data and generated outputs</strong>
                  </td>
                  <td>
                    ESG questionnaire responses, assessment progress, scores,
                    graphs, benchmarking indicators, suggestions and generated
                    PDF outputs.
                  </td>
                  <td>Provided by the user and generated by EcoTrack.</td>
                </tr>

                <tr>
                  <td>
                    <strong>Subscription and billing-related data</strong>
                  </td>
                  <td>
                    Subscription status, payment confirmation, billing-related
                    identifiers and cancellation information. Payment-card
                    details are processed by Stripe and are not stored in full
                    by EcoTrack.
                  </td>
                  <td>Provided by the user and received from Stripe.</td>
                </tr>

                <tr>
                  <td>
                    <strong>Technical and security data</strong>
                  </td>
                  <td>
                    Authentication-session information, technical browser
                    storage, security logs and information necessary to operate
                    and protect the service.
                  </td>
                  <td>Generated during service use.</td>
                </tr>

                <tr>
                  <td>
                    <strong>Communications and requests</strong>
                  </td>
                  <td>
                    Support messages, feedback, privacy-rights requests,
                    subscription-management information and account-deletion
                    requests.
                  </td>
                  <td>Provided by the user.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">4</span>
            Purposes and legal bases
          </h2>

          <p>
            Personal data are processed only where a lawful basis applies. The
            main purposes and legal bases are described below.
          </p>

          <div className="privacy-table-wrapper">
            <table className="privacy-table">
              <thead>
                <tr>
                  <th>Purpose</th>
                  <th>Data involved</th>
                  <th>Legal basis</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    Creating accounts, enabling login and providing EcoTrack
                    functionality.
                  </td>
                  <td>
                    Account, authentication, onboarding and assessment data.
                  </td>
                  <td>
                    Performance of a contract or steps requested before
                    entering into a contract.
                  </td>
                </tr>

                <tr>
                  <td>
                    Producing ESG scores, graphs, summaries, suggestions and
                    downloadable outputs requested by the user.
                  </td>
                  <td>Assessment answers and organisation profile data.</td>
                  <td>
                    Performance of the EcoTrack service contract.
                  </td>
                </tr>

                <tr>
                  <td>
                    Processing subscription purchases, monitoring subscription
                    status and enabling subscription management and cancellation
                    through Stripe Customer Portal.
                  </td>
                  <td>Account, subscription and payment-related data.</td>
                  <td>
                    Performance of the contract and, where applicable,
                    compliance with legal obligations.
                  </td>
                </tr>

                <tr>
                  <td>
                    Maintaining platform security, authentication integrity,
                    fraud prevention and prevention of misuse.
                  </td>
                  <td>Technical, authentication and security-related data.</td>
                  <td>
                    Legitimate interests of the Controller in operating and
                    protecting EcoTrack securely.
                  </td>
                </tr>

                <tr>
                  <td>
                    Answering support requests, receiving feedback and
                    processing account-deletion or privacy-rights requests.
                  </td>
                  <td>Contact, account and communication data.</td>
                  <td>
                    Performance of the service relationship, compliance with
                    legal obligations and legitimate interests in responding to
                    service communications.
                  </td>
                </tr>

                <tr>
                  <td>
                    Maintaining payment, contractual or accounting records
                    required by law.
                  </td>
                  <td>Billing and transaction-related information.</td>
                  <td>Compliance with legal obligations.</td>
                </tr>
                <tr>
  <td>
    Confirming that EcoTrack does not use personal data for advertising,
    behavioural marketing, profiling or sale to third parties.
  </td>
  <td>
    Not applicable. EcoTrack does not currently process personal data for these
    purposes.
  </td>
  <td>
    Not applicable. If optional marketing, profiling or non-essential analytics
    are introduced in the future, this Privacy Policy will be updated and, where
    required by law, a separate user choice or consent mechanism will be provided.
  </td>
</tr>
              </tbody>
            </table>
          </div>

        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">5</span>
            Automated score generation and suggestions
          </h2>

          <p>
            <strong>5.1</strong> EcoTrack uses automated rules-based processing
            to calculate ESG scores, prepare graphs and summaries, identify
            lower-performing ESG areas and generate indicative suggestions
            based on questionnaire answers and organisation profile information.
          </p>

          <p>
            <strong>5.2</strong> These outputs are provided for informational
            and business-support purposes only. They do not constitute legal,
            regulatory, certification, audit, investment or professional
            advice.
          </p>

          <p>
            <strong>5.3</strong> EcoTrack outputs are not used by the
            Controller to make decisions that produce legal effects or
            similarly significant effects concerning an individual.
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">6</span>
            Whether providing data is mandatory
          </h2>

          <p>
            Account and authentication information required during registration
            and login is necessary in order to create and access an EcoTrack
            account.
          </p>

          <p>
            Information required during onboarding and the ESG questionnaire is
            necessary to produce the requested assessment results and
            suggestions. If required information is not supplied, EcoTrack may
            be unable to calculate or display complete outputs.
          </p>

          <p>
            Payment-related information is necessary only where the user chooses
            to purchase paid access. Payment-card details are submitted through
            Stripe&apos;s hosted checkout environment rather than directly to
            EcoTrack.
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">7</span>
            Service providers and recipients
          </h2>

          <p>
            Personal data may be made available to service providers only where
            necessary to provide, protect, administer or support EcoTrack, or
            where required by law.
          </p>

          <div className="privacy-table-wrapper">
            <table className="privacy-table">
              <thead>
                <tr>
                  <th>Provider or category</th>
                  <th>Purpose</th>
                  <th>Environment</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <strong>Firebase / Google Cloud</strong>
                  </td>
                  <td>
                    Authentication, database functionality and technical cloud
                    infrastructure used by EcoTrack.
                  </td>
                  <td>EcoTrack application functionality.</td>
                  <td>
                    <span className="privacy-tag">Technical provider</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Stripe</strong>
                  </td>
                  <td>
                    Hosted checkout, payment processing, customer portal
                    access, subscription management, cancellation and
                    payment-security functions.
                  </td>
                  <td>Paid subscription checkout and billing.</td>
                  <td>
                    <span className="privacy-tag-third-party">
                      Payment provider
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Netsons</strong>
                  </td>
                  <td>
                    Website and hosting infrastructure supporting the live
                    Viridis website and the production publication of
                    EcoTrack.
                  </td>
                  <td>Production/live environment.</td>
                  <td>
                    <span className="privacy-tag">Hosting provider</span>
                  </td>
                </tr>

              

                <tr>
                  <td>
                    <strong>Professional or legal advisers and public authorities</strong>
                  </td>
                  <td>
                    Only where reasonably necessary for professional
                    administration, legal compliance, dispute management or a
                    valid authority request.
                  </td>
                  <td>Where applicable.</td>
                  <td>
                    <span className="privacy-tag-third-party">
                      Conditional recipient
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">8</span>
            International data transfers
          </h2>

          <p>
           The live EcoTrack interface is intended to be made available through the Viridis website infrastructure supported by Netsons. Some technical or payment providers used by EcoTrack, including Google / Firebase and Stripe, may process personal data or make them accessible from countries outside the European Economic Area.
          </p>

          <p>
            Where personal data are transferred outside the European Economic Area and a transfer safeguard is required, the transfer is carried out on the basis of an applicable adequacy decision, including the EU-U.S. Data Privacy Framework where applicable to the relevant certified recipient, and/or European Commission Standard Contractual Clauses or other lawful safeguards made available by the relevant provider.
          </p>

          <p>
            Additional information regarding applicable transfer safeguards may
            be requested by contacting{" "}
            <a
              className="privacy-link"
              href="mailto:serap.cevirgen@viridisconsultancy.com"
            >
              serap.cevirgen@viridisconsultancy.com
            </a>
            .
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">9</span>
            Data retention
          </h2>

          <p>
            Personal data are not retained longer than reasonably necessary for
            the purposes for which they were processed, subject to legal,
            accounting, security and dispute-management requirements.
          </p>

          <div className="privacy-table-wrapper">
            <table className="privacy-table">
              <thead>
                <tr>
                  <th>Data category</th>
                  <th>Retention criterion</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <strong>Account, profile and authentication data</strong>
                  </td>
                  <td>
                    Retained while the account remains active and until the
                    account-deletion request is processed. Where cancellation is
                    scheduled at the end of a paid subscription period,
                    processing may continue as necessary to provide access until
                    that date, unless earlier deletion is requested and
                    completed. Further retention may apply where necessary to
                    comply with legal obligations or establish, exercise or
                    defend legal claims.
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Assessment answers and generated outputs</strong>
                  </td>
                  <td>
                    Retained within the account to provide dashboard history,
                    results and downloadable outputs, until account deletion or
                    earlier deletion where made available, subject to necessary
                    legal or dispute-related retention.
                  </td>
                </tr>
                 <tr>
                  <td>
                    <strong>Assessment data and administrative visibility</strong>
                  </td>
                  <td>
                    Assessment responses, scores, pillar results, benchmarking indicators, suggestions and generated outputs are stored in connection with the registered account in order to provide assessment history, reporting, service administration and account-deletion functionality. Within EcoTrack’s administrative analytics dashboard, assessment information may be displayed without direct customer identifiers, such as the account holder’s name or email address. Authorised personnel may access individual assessment information only where necessary to operate, maintain, support, secure or administer the EcoTrack service, or to respond to a verified user request.
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Payment and subscription records</strong>
                  </td>
                  <td>
                    Retained for the period necessary to administer the
                    subscription and comply with applicable accounting, tax and
                    legal record-keeping obligations.
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Support, subscription-management and deletion requests</strong>
                  </td>
                  <td>
                    Retained for the period reasonably necessary to respond to
                    the request, document its handling and manage possible
                    disputes or legal obligations.
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Technical and security data</strong>
                  </td>
                  <td>
                    Retained only for the period necessary to maintain service
                    security, investigate technical issues or prevent misuse,
                    subject to provider technical retention settings.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">10</span>
            Account closure and subscription cancellation
          </h2>

          <p>
            <strong>10.1</strong> Users may initiate closure of their EcoTrack
            account through the function available in the{" "}
            <strong>Profile &amp; Settings</strong> section of the service.
          </p>

          <p>
            <strong>10.2</strong> Where an active paid subscription exists,
            selecting <strong>Close account and cancel subscription</strong>
            redirects the user to Stripe Customer Portal. Stripe processes the
            subscription-management action and provides EcoTrack with
            subscription status and cancellation-related information needed to
            administer access and the account-closure process.
          </p>

          <p>
            <strong>10.3</strong> Once subscription cancellation is confirmed
            through that account-closure flow, an account-deletion request is
            submitted to the Controller for processing. Cancellation and
            account deletion are separate operations: account deletion is not
            completed merely because renewal is cancelled.
          </p>

          <p>
            <strong>10.4</strong> Where the subscription remains active until
            the end of an already-paid billing period, account and assessment
            information may continue to be processed as necessary to provide
            paid access until that period expires, unless earlier deletion is
            specifically requested and completed.
          </p>

          <p>
            <strong>10.5</strong> Where no active subscription exists, a user
            may submit an account-deletion request without first completing a
            Stripe subscription-cancellation step.
          </p>

          <p>
            <strong>10.6</strong> Following account deletion, certain billing,
            invoice, tax, security, cancellation-request or transaction records
            may remain retained where required to comply with legal obligations
            or for the establishment, exercise or defence of legal claims.
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">11</span>
            Security
          </h2>

          <p>
            Reasonable technical and organisational measures are used to
            protect personal data against unauthorised access, unlawful
            processing, alteration, disclosure, loss or destruction.
          </p>

          <p>
            EcoTrack relies on authentication controls and technical service
            providers as described in this Policy. No internet-based service
            can guarantee absolute security, and users remain responsible for
            protecting their login credentials.
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">12</span>
            Sensitive and third-party personal data
          </h2>

          <p>
            EcoTrack is designed for organisational ESG self-assessment. It is
            not designed for the submission of special categories of personal
            data, such as health data, biometric data, information concerning
            racial or ethnic origin, religious beliefs, political opinions,
            trade union membership or sexual orientation.
          </p>

          <p>
            Users should not submit sensitive personal information or
            unnecessary personal data relating to employees, suppliers,
            customers or other third parties in questionnaire answers or
            support communications.
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">13</span>
            Your rights
          </h2>

          <p>
            Subject to the conditions and limits provided by applicable data
            protection law, individuals whose personal data are processed may
            exercise the following rights:
          </p>

          <ul className="privacy-list">
            <li>request access to their personal data;</li>
            <li>request rectification of inaccurate or incomplete data;</li>
            <li>request erasure of personal data where applicable;</li>
            <li>request restriction of processing where applicable;</li>
            <li>object to processing based on legitimate interests;</li>
            <li>request data portability where applicable;</li>
            <li>
              withdraw consent at any time where processing is based on consent,
              without affecting earlier lawful processing.
            </li>
          </ul>

          <p style={{ marginTop: 16 }}>
            Requests may be sent to{" "}
            <a
              className="privacy-link"
              href="mailto:serap.cevirgen@viridisconsultancy.com"
            >
              serap.cevirgen@viridisconsultancy.com
            </a>
            . The Controller may request information necessary to verify the
            identity of the requester before acting on a request.
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">14</span>
            Right to lodge a complaint
          </h2>

          <p>
            Individuals who consider that their personal data have been
            processed in breach of applicable data protection law have the
            right to lodge a complaint with the competent supervisory
            authority.
          </p>

          <p>
            In Italy, the supervisory authority is the{" "}
            <strong>Garante per la protezione dei dati personali</strong>.
            Further information is available on the Garante&apos;s official
            website:
          </p>

          <p>
            <a
              className="privacy-link"
              href="https://www.garanteprivacy.it/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Garante per la protezione dei dati personali
            </a>
          </p>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">15</span>
            Related legal documents
          </h2>

          <p>
            Use of EcoTrack is also governed by the applicable contractual and
            legal documents available through the service.
          </p>

          <div className="privacy-documents">
            <Link className="privacy-document-link" to="/terms-and-conditions">
              Terms and Conditions
            </Link>

            <Link className="privacy-document-link" to="/cookie-policy">
              Cookie Policy
            </Link>

            <Link className="privacy-document-link" to="/refund-policy">
              Refund and Cancellation Policy
            </Link>

            <Link className="privacy-document-link" to="/legal-notice">
              Legal Notice
            </Link>

          </div>
        </section>

        <section className="privacy-card">
          <h2>
            <span className="privacy-number">16</span>
            Changes to this Policy
          </h2>

          <p>
            This Privacy Policy may be updated from time to time to reflect
            legal, technical or operational changes affecting EcoTrack.
          </p>

          <p>
            The date displayed at the top of this page indicates the most
            recent update. Where a material change requires additional notice
            or action under applicable law, that notice or action will be
            provided as required.
          </p>
        </section>

        <section className="privacy-contact">
          <h2>Contact</h2>

          <p>
            Privacy-related requests or questions concerning the processing of
            personal data in EcoTrack may be sent to:
          </p>

          <a href="mailto:serap.cevirgen@viridisconsultancy.com">
            serap.cevirgen@viridisconsultancy.com
          </a>
        </section>

        <footer className="privacy-footer">
          © 2026 Viridis by Serap Cevirgen · EcoTrack
        </footer>
      </main>
    </div>
  );
}